import { render, staticRenderFns } from "./PatientControlReservation.vue?vue&type=template&id=5c54b5c5&scoped=true&"
import script from "./PatientControlReservation.vue?vue&type=script&lang=ts&"
export * from "./PatientControlReservation.vue?vue&type=script&lang=ts&"
import style0 from "./PatientControlReservation.vue?vue&type=style&index=0&id=5c54b5c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c54b5c5",
  null
  
)

export default component.exports